// material
import { Stack, Box } from "@mui/material";
import { styled } from "@mui/material/styles";

// ----------------------------------------------------------------------
const AnimationStyle = styled(Stack)(() => ({
  position: "absolute",
  top: "-66px",
  right: "-215px",
  "@media (max-width: 1534px)": {
    top: "-48px",
    right: "-170px",
  },
  "@media (max-width: 1200px)": {
    top: "-39px",
    right: "-135px",
  },
  "@media (max-width: 900px)": {
    top: "-39px",
    right: "39px",
  },
  "@media (max-width: 500px)": {
    display: "none",
  },
  "@keyframes spin": {
    "100%": {
      transform: "rotate(360deg)",
    },
  },
}));

export default function Sub(props) {
  return (
    <Stack
      direction={{ xs: "column", md: "row" }}
      sx={{ borderBottom: "1px solid #ffffff80" }}
    >
      <div className="sub_txt">
        {props.title1} <br />
        {props.title2} <br />
        {props.title3}
      </div>
      <Stack
        alignItems="center"
        justifyContent="center"
        sx={{
          borderRight: "1px solid #ffffff80",
          width: { xs: "100%", md: "46%" },
          position: "relative",
        }}
      >
        <img
          src="/assets/subimg.png"
          style={{ width: "100%", height: "100%" }}
        />
        <AnimationStyle>
          <Box
            component="img"
            alt="text"
            src="/assets/text.png"
            sx={{
              width: { xs: "80px", lg: "100px", xl: "130px" },
              height: { xs: "80px", lg: "100px", xl: "130px" },
              animation: "spin 12s linear infinite",
            }}
          />
        </AnimationStyle>
      </Stack>
    </Stack>
  );
}
